module.exports = __webpack_public_path__ + "img/runeke_konsult.52cc15a1.png";